import {
  getApps,
  createApp,
  updateApp,
  deleteApp,
} from "@/api/apps";
import Vue from "vue";

const state = {
  list: [],
};

const mutations = {
  SET_LIST(state, list) {
    state.list = list;
  },
  ADD_ITEM(state, item) {
    state.list.push(item);
  },
  UPDATE_ITEM(state, updated) {
    const idx = state.list.findIndex((i) => i.id === updated.id);
    if (idx !== -1) Vue.set(state.list, idx, updated);
  },
  REMOVE_ITEM(state, id) {
    state.list = state.list.filter((item) => item.id !== id);
  },
};

const actions = {
  async fetchAll({ commit }) {
    try {
      const list = await getApps();
      commit("SET_LIST", list);
    } catch (e) {
      Vue.$toast.error(e, { duration: 0 });
    }
  },
  async create({ commit }, data) {
    const item = await createApp(data);
    commit("ADD_ITEM", item);
    return item;
  },
  async update({ commit }, { id, data }) {
    const item = await updateApp(id, data);
    commit("UPDATE_ITEM", item);
    return item;
  },
  async remove({ commit }, id) {
    await deleteApp(id);
    commit("REMOVE_ITEM", id);
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
